import React, {useEffect, useState} from 'react';
import Logo from '../../../assets/logo.png';
import { Auth, API, graphqlOperation } from 'aws-amplify';
import * as queries from '../../../graphql/queries';
import fetchSearchItemsNextToken from '../../../graphql/fetchSearchItemsNextToken';
import Storage from "@aws-amplify/storage";
import { customAPIRequest, getSignedUrl } from '../../auth/util/util';

function AdminLogo() {

    const [adminlogo, setAdminlogo] = useState(null);

    useEffect(() => {
        const initialFun = async() => {
            let userDetailsID = localStorage.getItem('userDetailsID');
            if(userDetailsID)
            {
                let userData = await API.graphql(graphqlOperation(queries.getUserProfileDetails, { id: userDetailsID }));
                let newData = userData.data.getUserProfileDetails;

                const moodleUserDetails = await customAPIRequest(
                    "core_user_get_users_by_field",
                    { field: "email", "values[0]": localStorage.getItem("email") }
                );

                let schoolDetails = undefined
                if(moodleUserDetails.data.length > 0) {
                    const assignedCourses = await customAPIRequest(
                        "core_enrol_get_users_courses",
                        { userid: moodleUserDetails.data[0].id }
                      );

                    
                    // let assignedCoursesToShow = [];  

                    for (let course of assignedCourses.data) {
                        let matchingIdNumber = course.idnumber;
                        if (matchingIdNumber.split("-").length > 3) {
                          let schoolCode = `${
                            matchingIdNumber.split("-")[
                              matchingIdNumber.split("-").length - 3
                            ]
                          }-${
                            matchingIdNumber.split("-")[
                              matchingIdNumber.split("-").length - 2
                            ]
                          }-${
                            matchingIdNumber.split("-")[
                              matchingIdNumber.split("-").length - 1
                            ]
                          }`;
              
                          const existingSchool = await fetchSearchItemsNextToken({
                            query: queries.searchChildSchools,
                            variables: {
                              limit: 100,
                              filter: {
                                unique_code: { eq: schoolCode },
                              },
                            },
                          });
                          if (existingSchool.length > 0) {
                            schoolDetails = existingSchool[0]
                          }
                        }
                      }
                }

                // If a user is a group school admin and a child school admin then the logo of the group school takes precedence and is shown to user of it exists
                let GroupAndChildAdminLogo = undefined
                if(newData.isSchoolAdmin === 1 && newData.isGroupSchoolAdmin === 1) {
                  const groupSchoolForGroupSchoolAdmin = await fetchSearchItemsNextToken({ query: queries.searchGroupSchools, variables: { limit: 100, filter: { group_school_admin_email: { eq: localStorage.getItem('email') } } } })
                  if(groupSchoolForGroupSchoolAdmin[0].logo !== null) {
                    GroupAndChildAdminLogo = groupSchoolForGroupSchoolAdmin[0].logo
                  }
                }

                let SchoolAdminsSchoolLogo = undefined
                if(newData.isSchoolAdmin === 1) {
                    const schoolForSchoolAdmin = await fetchSearchItemsNextToken({ query: queries.searchChildSchools, variables: { limit: 100, filter: { school_admin_email: { eq: localStorage.getItem('email') } } } })
                    if(schoolForSchoolAdmin.length>0 && schoolForSchoolAdmin[0].logo) {
                        // await getSignedUrl(schoolForSchoolAdmin[0].logo, {level: 'public'}).then(setAdminlogo).catch(err => console.log(err));
                        if(schoolForSchoolAdmin[0].logo !== null) {
                          SchoolAdminsSchoolLogo = schoolForSchoolAdmin[0].logo
                        }
                    }
                } 
                
                let GroupAdminGroupSchoolLogo = undefined
                if(newData.isGroupSchoolAdmin === 1) {
                  const groupSchoolForGroupSchoolAdmin = await fetchSearchItemsNextToken({ query: queries.searchGroupSchools, variables: { limit: 100, filter: { group_school_admin_email: { eq: localStorage.getItem('email') } } } })
                  if(groupSchoolForGroupSchoolAdmin[0].logo !== null) {
                    GroupAdminGroupSchoolLogo = groupSchoolForGroupSchoolAdmin[0].logo
                  }
                }
                
                if(newData.referralCode!='')
                {
                    //if user is part of a school and is under an institute admin then school logo takes priority
                    if(schoolDetails) {
                        if(!newData.isSchoolAdmin && !newData.isGroupSchoolAdmin) {
                            if(schoolDetails.logo !== null) {
                              await getSignedUrl(schoolDetails.logo, {level: 'public'}).then(setAdminlogo).catch(err => console.log(err));
                            }
                        }
                    } else {
                        if(newData.referralCode !== null) {
                          let userDataQuery=await fetchSearchItemsNextToken({query:queries.searchUserProfileDetails,variables:{ filter: {isAdmin: {eq: 1}, referralCode: {eq: newData.referralCode}}, limit: 500 }});
                          
                          if(userDataQuery.length>0)
                          {
                              if(userDataQuery[0].adminLogo!=null)
                              {
                                  await getSignedUrl(userDataQuery[0].adminLogo, {level: 'public'}).then(setAdminlogo).catch(err => console.log(err));
                              } else {
                                  setAdminlogo(Logo)
                              }
                          }
                        } else {
                          setAdminlogo(Logo)
                        }
                    }
                } else if(schoolDetails){
                    if(!newData.isSchoolAdmin && !newData.isGroupSchoolAdmin) {
                        if(schoolDetails.logo !== null) {
                          await getSignedUrl(schoolDetails.logo, {level: 'public'}).then(setAdminlogo).catch(err => console.log(err));
                        } else{
                            setAdminlogo(Logo)
                        }
                    }
                } else if (SchoolAdminsSchoolLogo) {
                    await getSignedUrl(SchoolAdminsSchoolLogo, {level: 'public'}).then(setAdminlogo).catch(err => console.log(err));
                } else if (GroupAndChildAdminLogo) {
                  await getSignedUrl(GroupAndChildAdminLogo, {level: 'public'}).then(setAdminlogo).catch(err => console.log(err));
                } else if (GroupAdminGroupSchoolLogo) {
                  await getSignedUrl(GroupAdminGroupSchoolLogo, {level: 'public'}).then(setAdminlogo).catch(err => console.log(err));
                } else {
                    setAdminlogo(Logo)
                }
            } else {
              setAdminlogo(Logo)
            }
        }
    initialFun()
    }, [])
    

    return (
        <img src={adminlogo} alt='MySphere' width={140}/>
    )
}

export default AdminLogo